import React from "react";
import { connect } from "react-redux";
import {
  Input,
  Row,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Col,
  Label
} from "reactstrap";
import { templateActions } from "../../../../../store/actions/cms/template/template.action";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import ColorPickerFacade from "../../../../../components/UI/Buttons/ColorPickerFacade";
import { deepClone, setValueToNestedObject } from "../../../../../helpers/objectHelper";
import { UrlMultiInput } from "../../../../components/editor/tools/UrlMultiInput/UrlMultiInput";
import JirangoSwitch from "../../../../../components/UI/Switch/JirangoSwitch";
import { templateHelper } from "../../helpers/templateHelper";

class BackgroundSettings extends React.Component {
  state = {
    isMediaVaultOpen: false
  };
  handleUpdate = template => {
    const { dispatch } = this.props;
    dispatch(templateActions.softUpdate(template));
  };

  handleChange = (color, e, path, fallbackUnit = null) => {
    const { template } = this.props;
    const names = path.split(".");
    let templateCopy = deepClone(template);
    let value = templateHelper.getValueFromInput(e, color);
    let unit = templateHelper.getUnit(templateCopy, names);
    if (!unit && fallbackUnit) unit = fallbackUnit;
    if (parseInt(value) && unit.length < 4) {
      value += unit;
    }
    templateCopy.content = deepClone(setValueToNestedObject(
      names,
      value,
      templateCopy.content
    ));
    this.handleUpdate(templateCopy);
    if(path == 'main.backgroundColor'){
      this.handleChange(color, e, 'main.background');
    }
  };
  setAttribute = (attr, path) => {
    const { template } = this.props;
    const names = path.split(".");
    let templateCopy = deepClone(template);

    if (names.length === 3) {
      templateCopy.content[names[0]][names[1]][names[2]] = attr;
    } else {
      templateCopy.content[names[0]][names[1]] = attr;
    }
    this.handleUpdate(templateCopy);
  };

  changeBackgroundImage = url => {
    const { template } = this.props;
    const templateCopy = deepClone(template);
    templateCopy.content.main.background = `url('${url}')  no-repeat center center / cover`;
    templateCopy.content.main.backgroundSize = `cover`;
    templateCopy.content.main.backgroundUrl = url;
    this.handleUpdate(templateCopy);
  };
  setBackgroundImage = url => {
    const { template } = this.props;
    const templateCopy = deepClone(template);
    templateCopy.content.main.background = `url('${url}')  no-repeat center center / cover`;
    templateCopy.content.main.backgroundSize = `cover`;
    templateCopy.content.main.backgroundUrl = url;
    this.handleUpdate(templateCopy);
  };
  toggleMediaVault = () => {
    this.setState({ isMediaVaultOpen: !this.state.isMediaVaultOpen });
  };
  enableVideoBackground = e => {
    const { template } = this.props;
    const templateCopy = deepClone(template);
    let enabled = e.target.checked;
    if (!enabled) {
      templateCopy.content.main.youtubeUrl = "";
    }
    templateCopy.content.main.videoBackgroundEnabled = enabled;
    this.handleUpdate(templateCopy);
  };
  handlePaste = () => {
    let ytUrlStandard = "https://www.youtube.com/watch?v=";
    navigator.clipboard.readText().then(text => {
      if (text.includes(ytUrlStandard)) {
        const { template } = this.props;
        const templateCopy = deepClone(template);
        templateCopy.content.main.youtubeUrl = text;
        this.handleUpdate(templateCopy);
      }
    });
  };
  render() {
    const { template } = this.props;
    if (template === undefined) return null;
    return (
      <div style={{ paddingTop: "10px" }}>
        <Row>
          <Col className="list-setting-item-title">
            <Label>
              <SystemLabel name="BackgroundColor" />
            </Label>
          </Col>
          <Col className="list-setting-item-input">
            <ColorPickerFacade
              color={template.content.main.backgroundColor}
              onChange={(color, e) =>
                this.handleChange(color, e, "main.backgroundColor")
              }
              path="main.backgroundColor"
            />
          </Col>
        </Row>
        <hr />
        <Row>
          <Col className="list-setting-item-title">
            <Label>
              <SystemLabel name="BackgroundImage" />
            </Label>
          </Col>
        </Row>
        <Row>
          <Col className="list-setting-item-title">
            {template && template.content.main.backgroundUrl && (
              <img
                style={{ cursor: "pointer", width: "120px", marginTop: "5px" }}
                onClick={() =>
                  this.setAttribute(
                    `url('${template.content.main.backgroundUrl}')  no-repeat center center / cover`,
                    "main.background"
                  )
                }
                alt=""
                src={template.content.main.backgroundUrl}
              />
            )}
          </Col>
        </Row>
        <UrlMultiInput onChange={this.setBackgroundImage} setImage={this.setBackgroundImage} url={template.content.main.backgroundUrl} />
        <hr />
        <Row>
          <Col
            className="list-setting-item-title"
            style={{ display: "inline-flex" }}
          >
            <Label>
              <SystemLabel name="VideoBackground" />
            </Label>
          </Col>
          <Col style={{ textAlign: "right", }}>
            <JirangoSwitch
              onChange={this.enableVideoBackground}
              isChecked={
                template.content.main.videoBackgroundEnabled !== true
                  ? false
                  : true
              }
            />
          </Col>
        </Row>
        {template.content.main.videoBackgroundEnabled === true ? (
          <Row style={{ marginTop: "15px" }}>
            <Col className="list-setting-item-title">
              <InputGroup>
                <Input
      autoComplete="jirango-nofill"
                  onChange={e => this.handleChange(null, e, "main.youtubeUrl")}
                  value={
                    template.content.main.youtubeUrl !== "unset"
                      ? template.content.main.youtubeUrl
                      : ""
                  }
                />
                <InputGroupAddon onClick={this.handlePaste} addonType="append">
                  <InputGroupText
                    style={{ backgroundColor: "#fff", cursor: "pointer" }}
                  >
                    <i className="fa fa-paste" />
                  </InputGroupText>
                </InputGroupAddon>
              </InputGroup>
              <p
                className="text-muted"
                style={{ lineHeight: "initial", marginTop: "5px" }}
              >
                <SystemLabel name="VideoLinkInstruction" />
              </p>
            </Col>
          </Row>
        ) : null}
        <br />
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    template: state.template.template
  };
}
export default connect(mapStateToProps)(BackgroundSettings);
